import {BenjiKIVSymbol} from "../reels/BenjiKIVSymbol";
import {SymbolPositionData} from "../../core/reel/ReelInterfaces";
import {BenjiKIVWildSymbol} from "../reels/BenjiKIVWildSymbol";
import {BenjiKIVScatterSymbol} from "../reels/BenjiKIVScatterSymbol";

/**
 * Created by Jerker Nord on 2022-11-15.
 */

export class BenjiKIVPoolWildSymbols {

   private _symbols:BenjiKIVWildSymbol[];

   public init():void {
      this._symbols = [];
      for(let i:number = 0; i < 9; i++) {
         this._symbols.push(this.createNewSymbol());
      }
   }

   private createNewSymbol():BenjiKIVWildSymbol {
      return new BenjiKIVWildSymbol();
   }

   public getSymbol(symbolName:string, symbolPositionData:SymbolPositionData):BenjiKIVWildSymbol {
      for(let i:number = 0; i < this._symbols.length; i++) {
         if(this._symbols[i].isUsed == false) {
            this._symbols[i].isUsed = true;
            this._symbols[i].symbolName = symbolName;
            this._symbols[i].stackedSymbolName = symbolName;
            this._symbols[i].reelPosition = symbolPositionData.position;
            this._symbols[i].reelId = symbolPositionData.reelID;
            return this._symbols[i];
         }
      }
      //console.log("Creating more Wild Syms!");
      this._symbols.push(this.createNewSymbol());
      return this.getSymbol(symbolName, symbolPositionData);
   }

   public getWildSymbolOnReel(reelId:number):BenjiKIVWildSymbol{
      for(let i:number = 0; i < this._symbols.length; i++) {
         if(this._symbols[i].isUsed == true && this._symbols[i].reelId == reelId) {
            return this._symbols[i];
         }
      }
      throw new Error("BenjiKIVPoolWildSymbols: No Wild on that reel!");
   }
}